import React, { PureComponent} from 'react';
import styles from './Sponsors.css';
import { cdnURL } from '../../lib/utils';

class Sponsors extends PureComponent {

  static coOrganizor = [
    { src: `${cdnURL}sponsor/01.png`, alt: 'SONY MUSIC' },
  ];

  static coMedia = [
    { src: `${cdnURL}sponsor/02.png`, alt: '東森新聞雲' },
  ];

  static sponsorList = [
    { src: `${cdnURL}sponsor/03.png`, alt: 'GASH' },
    { src: `${cdnURL}sponsor/04.png`, alt: 'The FAMOUS GROUSE' },
    { src: `${cdnURL}sponsor/05.png`, alt: 'MAKE UP FOR EVER' },
    { src: `${cdnURL}sponsor/06.png`, alt: 'Savanna' },
    { src: `${cdnURL}sponsor/07.png`, alt: 'Schweppes' },
    { src: `${cdnURL}sponsor/08.png`, alt: 'MAGIPEA' },
    { src: `${cdnURL}sponsor/09.png`, alt: '海倫仙度絲' },
    { src: `${cdnURL}sponsor/10.png`, alt: '星采 醫美保養品首選' },
    { src: `${cdnURL}sponsor/11.png`, alt: 'OralB' },
    { src: `${cdnURL}sponsor/12.png`, alt: 'whisper 好自在' },
  ];

  render() {
    return (
      <div className={styles.sponsors}>
        <div className={styles.flexContainer}>
          <div className={styles.section}>
            <div className={styles.coOrganizorLabel}>
              協辦單位
            </div>
            <div className={styles.sponsorContainer}>
              {
                Sponsors.coOrganizor.map(({ src, alt }, index) =>
                <div className={styles.sponsorItemSony} key={index}>
                  <img src={src} alt={alt} onLoad={(e) => e.target.width /= 2 }/>
                </div>)
              }
            </div>
          </div>

          <div className={styles.section}>
            <div className={styles.coOrganizorLabel}>
              協辦媒體
            </div>
            <div className={styles.sponsorContainer}>
              {
                Sponsors.coMedia.map(({ src, alt }, index) =>
                <div className={styles.sponsorItemSony2} key={index}>
                  <img src={src} alt={alt} onLoad={(e) => e.target.width /= 2 }/>
                </div>)
              }
            </div>
          </div>

          <div className={styles.sponsorContainer2}>
            <div className={styles.sponsorList}>
            <div className={styles.sponsorLabel2}>
              <span className={styles.sponsorTitle}>贊助商</span>
            </div>
            {
              Sponsors.sponsorList.map(({ src, alt }, index) =>
              <div className={styles.sponsorItem} key={ index }>
                <img onLoad={(e) => e.target.width /= 2 } src={ src } alt={ alt } />
              </div>)
            }
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default Sponsors;


// WEBPACK FOOTER //
// ./src/sections/Sponsors/index.js